export default __webpack_public_path__ + "static/media/congrats-baloons.aa26915d.svg";